import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { fadeInOut, fadeInOutHidden } from 'src/app/animations/animations';
import { IErrorMessage } from 'src/app/models/app/Interfaces/errorMessages';
import { ListItem } from 'src/app/models/app/Interfaces/list-item';
import { ListService } from 'src/app/services/lists/list.service';
import dayjs from 'dayjs';
import { BackEndDateFormat } from 'src/app/constants/strings';
import { GtmEventIds } from 'src/app/constants/gtm-event-ids';
import { GoogleTagManagerService } from 'src/app/services/google-analytics/google-tag-manager.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-question-date-expiry',
    templateUrl: './question-date-expiry.component.html',
    styleUrls: ['./question-date-expiry.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => QuestionDateExpiryComponent),
        }
    ],
    animations: [
        fadeInOut,
        fadeInOutHidden
    ],
    imports: [NgClass, FormsModule]
})
export class QuestionDateExpiryComponent implements OnInit, ControlValueAccessor {

    public disabled: any = false;
    public monthValue: string | number | null = null;
    public yearValue: string | number | null = null;
    public selectedMonth: string | null = null;
    public selectedYear: string | null = null;
    public yearsList: Array<ListItem> = [];
    public monthsList: Array<ListItem> = [];
    public gtmEventIds = GtmEventIds;
    public idText: string = "";

    private ngControl: NgControl | undefined;
    private onChange = (_: any) => { };
    private onTouch = (_: any) => { };

    @Input() questionText: string = '';
    @Input() monthPlaceHolder: string = 'Month';
    @Input() yearPlaceHolder: string = 'Year';
    @Input() errorText: string = '';
    @Input() formControlName: any;
    @Input() errorMessages: IErrorMessage[] = [];
    @Input() addHotJarSuppressionTag: boolean = false;
    @Input() readOnly: boolean = false;
    @Input() returnValueName: string = 'code';

    constructor(private injector: Injector, private listService: ListService, private googleTagManagerService: GoogleTagManagerService) { }

    ngOnInit(): void {
        this.ngControl = this.injector.get(NgControl);
        this.yearsList = this.listService.getFutureYearsList(10);
        this.monthsList = this.listService.getShortMonthsList();
        this.idText = this.getIdText();
    }

    public writeValue(obj: any): void {
        const date = dayjs(obj, BackEndDateFormat, true);
        if (date.isValid()) {
            this.yearValue = date.format('YYYY');
            this.monthValue = date.format('MM');
        }
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    public setDisabledState(val: any) {
        this.disabled = val;
    }

    public optionSelected(isMonth: boolean , option: any){
        if(isMonth === true){
            this.monthValue = option.code; 
            this.selectedMonth = option.value;
        }else{
            this.yearValue = option.code;
            this.selectedYear = option.value;
        }
        
        this.onInputChange()
    }

    public onInputChange() {
        if (!this.ngControl?.touched && this.yearValue && this.monthValue) {
            this.onTouch(true);
        }

        this.onChange(this.getDate());

    }

    private getIdText(): string {
        return `dd-${this.formControlName}`;
    }


    public getErrorMessage(): string {
        let result: string = '';

        if (this.ngControl?.errors) {
            if (this.errorMessages.length > 0) {
                for (const errorMessage of this.errorMessages) {

                    const controlError = this.ngControl.errors[errorMessage.key]
                    if (controlError) {
                        result = errorMessage.message;
                        break;
                    }
                }
                if (result === '') {
                    result = this.errorText;
                }
            } else {
                result = this.errorText;
            }
        }

        return result
    }

    public shouldShowError(): boolean {
        return (this.ngControl?.invalid === true) && (this.ngControl?.dirty === true) && (this.ngControl?.touched === true);
    }

    private getDate(): string | null {
        if (this.monthValue && this.yearValue) {
            let endOfMonth = dayjs(`${this.yearValue}-${this.monthValue}-01`, BackEndDateFormat, true).endOf('month');
            if (endOfMonth.isValid()) {
                return endOfMonth.format(BackEndDateFormat);
            }
        }
        return null;
    }
    
    public triggerGtmEvent(eventId: string, html_id: string){
        this.googleTagManagerService.trackAction({
            event: 'dropdown',
            action: 'focus',
            html_id: html_id,
            name: eventId
        });
    }
}
